import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import {
  getOrgClaimInitConfigs,
  createOrgClaimInitConfig,
  updateOrgClaimInitConfig,
  deleteOrgClaimInitConfig,
} from '../../../lib/orgRequests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

function extractError(e) {
  if (e.response && e.response.data) { return e.response.data; }
  return 'An unexpected error occurred';
}

export function* getOrgClaimInitConfigsRequestWatcher() {
  for (;;) {
    var request = yield take(types.GET_ORG_CLAIM_INIT_CONFIGS_REQUEST);
    try {
      var response = yield call(getOrgClaimInitConfigs, request.payload);
      yield put(actions.getOrgClaimInitConfigsSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrgClaimInitConfigsFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* createOrgClaimInitConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.CREATE_ORG_CLAIM_INIT_CONFIG_REQUEST);
    try {
      var response = yield call(createOrgClaimInitConfig, request.payload);
      yield put(actions.createOrgClaimInitConfigSuccess(response.data));
      yield put(actions.getOrgClaimInitConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.createOrgClaimInitConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updateOrgClaimInitConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.UPDATE_ORG_CLAIM_INIT_CONFIG_REQUEST);
    try {
      var response = yield call(updateOrgClaimInitConfig, request.payload.guid, request.payload);
      yield put(actions.updateOrgClaimInitConfigSuccess(response.data));
      yield put(actions.getOrgClaimInitConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.updateOrgClaimInitConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteOrgClaimInitConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.DELETE_ORG_CLAIM_INIT_CONFIG_REQUEST);
    try {
      yield call(deleteOrgClaimInitConfig, request.payload.guid);
      yield put(actions.deleteOrgClaimInitConfigSuccess(request.payload.guid));
      yield put(actions.getOrgClaimInitConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.deleteOrgClaimInitConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
